<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title">Admission Inquiry Report</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <label>Session </label>
          <select class="form-control" v-model="filter.SemesterID">
            <option value="">--Select Session--</option>
            <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Degree </label>
          <select class="form-control" v-model="filter.DegreeID">
            <option value="">--Select Degree--</option>
            <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Program</label>
          <select class="form-control" v-model="filter.ProgramID">
            <option value="0">--Select Program--</option>
            <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>City</label>
          <select class="form-control" v-model="filter.CityID">
            <option value="0">--Select City--</option>
            <option v-for="item in city" v-bind:value="item.CityID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Date From </label>
            <input v-model="filter.DateFrom" type="date" class="form-control" />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Date To </label>
            <input v-model="filter.DateTo" type="date" class="form-control" />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group float-right">
            <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="btnSearch()">Print</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        departments: [],
        programs: [],
        selDegreeID: 0,
        semesters: [],
        degrees: [],
        city: [],
        filter: { SemesterID: '', ProgramID: 0, DegreeID: '', Name: '', DateFrom: '', DateTo: '', CityID: 0 },

      }
    },

    created: function () {
    },

    mounted: function () {
      this.pageLoad();
    },


    methods: {

      pageLoad: function () {
        var vm = this;
        startReq();

        axios.post('/api/AdmissionApi/prospectStudentsPageLoad')
          .then(function (pl) {
            endReq();
            vm.semesters = pl.data["sem"];
            vm.degrees = pl.data["deg"];
            vm.category = pl.data["category"];
            vm.programs = pl.data["programs"];
            vm.city = pl.data["city"];
          })
      },


      btnSearch() {

        startReq();

        var vm = this;

        axios.post('/api/AdmissionApi/AdmissionInquiryReport', {
          filter: vm.filter,
        })
          .then(function (res) {
            window.open("/Admission/AdmissionInquiryReportPrint");
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },


    }
  })</script>





// WEBPACK FOOTER //
// src/components/onlineadmission/AdmissionInquiryReport.vue